import * as types from "./constant"

const initialState = {
  loading: false,
  userDetails: [],
  ViewEmployees: [],
  Subscription: [],
  usersSubscriptionPlan : [],
  error: "",
}

const SuperUsers = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_SU_USER_START:
      state = {
        ...state,
        loading: true,
      }
      break
    case types.GET_SU_USER_SUCCESS:
      state = {
        ...state,
        loading: false,
        userDetails: action.payload,
      }
      break
    case types.GET_SU_USER_FAILED:
      state = {
        ...state,
        loading: false,
        userDetails: action.payload,
      }
    case types.GET_SU_USER_RESET:
      state = {
        ...state,
        loading: false,
        userDetails: [],
      }
      break

    case types.GET_SU_EMP_START:
      state = {
        ...state,
        loading: true,
      }
      break
    case types.GET_SU_EMP_SUCCESS:
      state = {
        ...state,
        loading: false,
        ViewEmployees: action.payload,
      }
      break
    case types.GET_SU_EMP_FAILED:
      state = {
        ...state,
        loading: false,
        ViewEmployees: action.payload,
      }
      break
    case types.GET_SU_EMP_RESET:
      state = {
        ...state,
        loading: false,
        ViewEmployees: [],
      }
      break

    //Subscription Status

    case types.GET_SU_SUBS_START:
      state = {
        ...state,
        loading: true,
      }
      break
    case types.GET_SU_SUBS_SUCCESS:
      state = {
        ...state,
        loading: false,
        Subscription: action.payload,
      }
      break
    case types.GET_SU_SUBS_FAILED:
      state = {
        ...state,
        loading: false,
        Subscription: action.payload,
      }
      break
    case types.GET_SU_SUBS_RESET:
      state = {
        ...state,
        loading: false,
        Subscription: [],
      }

      case types.GET_SU_SUBS_USERS_START:
        state = {
          ...state,
          loading: true,
        }
        break
      case types.GET_SU_SUBS_USERS_SUCCESS:
        state = {
          ...state,
          loading: false,
          usersSubscriptionPlan: action.payload,
        }
        break
      case types.GET_SU_SUBS_USERS_FAILED:
        state = {
          ...state,
          loading: false,
          usersSubscriptionPlan: action.payload,
        }
        break
      case types.GET_SU_SUBS_USERS_RESET:
        state = {
          ...state,
          loading: false,
          usersSubscriptionPlan: [],
        }  
  }
  // User subscription plan

  return state
}

export default SuperUsers
